// extracted by mini-css-extract-plugin
export var wrapper = "MenuLayout-module--wrapper--2DoZw";
export var menuLink = "MenuLayout-module--menuLink--1CE3V";
export var currentPage = "MenuLayout-module--currentPage--1xPAW";